export default __webpack_public_path__ + "static/match-group-dark-mode-230e3011bacba9b24691d93104067cca.png";